import PropTypes from 'prop-types';
import styled from 'react-emotion';

const calcOffset = width => Math.abs(width / 2) * -1;

// ---
// Base WidthContainer Component.
// ---
const WidthContainer = styled.section`
  width: ${props => `${props.width}${props.unit}`};
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: ${props => `${calcOffset(props.width)}${props.unit}`};
  margin-right: ${props => `${calcOffset(props.width)}${props.unit}`};
`;
WidthContainer.propTypes = {
  width: PropTypes.number,
  unit: PropTypes.string,
};
WidthContainer.propTypes = {
  width: 100,
  unit: 'vw',
};

// ---
// Shorthand Components.
// ---
const FullWidthContainer = WidthContainer;

export { FullWidthContainer, WidthContainer };



// WEBPACK FOOTER //
// ../sthzgnet-branding/lib/WidthContainers/widthContainers.jsx